/**
 * Locations admin page localization (mk).
 */
export default {
  title: "Локации",
  subtitle: "Управувајте физички локации и LIS мапирања",
  add: "Додади локација",
  edit: "Уреди",
  delete: "Избриши",
  refresh: "Освежи",
  navigate: "Отвори локација",
  add_title: "Додади локација",
  add_subtitle: "Создадете нова физичка локација и LIS мапирање",
  subtitle_name: "Локација",
  subtitle_id: "ID на локација",
  subtitle_lis_id: "Клуч",
  subtitle_name_tooltip: "Назив на локацијата",
  subtitle_id_tooltip: "Системски идентификатор",
  subtitle_lis_id_tooltip: "ID на апарат во LIS iLab",
  edit_title: "Уреди локација",
  delete_title: "Избриши локација",
  delete_message: "Оваа локација ќе биде трајно избришана.",
  delete_has_instruments:
    "Оваа локација не може да се избрише бидејќи сè уште има доделени апарати. Прво отстранете ги или преместете ги.",
  empty: "Сè уште нема локации",

  list: {
    status_total: "{count} локација | {count} локации",
    status_no_instruments: "Без апарати",
    status_with_instruments: "{count} апарат | {count} апарати",
    description: "Локациите ги групираат апаратите по објект, оддел или сектор.",
    empty: {
      title: "Сè уште нема локации",
      description: "Додадете прва локација за да започнете да организирате апарати.",
    },
  },

  detail: {
    description: "Апарати инсталирани на оваа локација.",
    delete: "Избриши локација",
    edit: "Уреди локација",
    save: "Зачувај промени",
    reset: "Ресетирај",
    details_tab: "Детали",
    instruments: {
      tab: "Апарати",
      empty_title: "Нема апарати на оваа локација",
      empty_description: "Доделете апарат на оваа локација за да го видите овде.",
    },
    toolbar: {
      refresh_instruments: "Освежи апарати",
      add_instrument: "Додади апарат",
    },
  },

  tabs: {
    all: "Сите локации",
  },

  columns: {
    location: "Локација",
    name: "Име",
    mapping_key: "Клуч",
    mapping_key_tooltip: "Надворешен клуч за идентификација на локацијата во поврзани LIS/HIS системи",
    note: "Белешка",
    instrument_count: "Апарати",
    actions: "Акции",
  },

  fields: {
    name: "Име",
    name_hint: "Приказно ime прикажано низ целиот систем",
    mapping_key: "Клуч",
    mapping_key_hint: "ID на апарат во LIS iLab",
    note: "Белешка",
    note_hint: "По желба — видливо во заглавието на локацијата и насоките",
  },

  validation: {
    name_required: "Името е задолжително",
    name_too_long: "Името мора да биде 100 знаци или помалку",
    name_taken: "Веќе постои локација со ова име",
    mapping_key_required: "Клучот е задолжителен",
    mapping_key_too_long: "Клучот мора да биде 100 знаци или помалку",
    mapping_key_taken: "Веќе постои локација со овој клуч",
    note_too_long: "Белешката мора да биде 500 знаци или помалку",
  },

  loadFailed: "Не успеа вчитувањето на локациите",
  snackbar_added: 'Локација "{name}" е додадена',
  snackbar_updated: 'Локација "{name}" е ажурирана',
  snackbar_deleted: 'Локација "{name}" е избришана',
};
